// Copyright © 2026 Qcells. All rights reserved.
//
// This software is proprietary and confidential. Unauthorized use,
// duplication, or distribution of software is strictly prohibited.
//
// Helios sunburst mark. The header's Ask EnergyFluo trigger no longer uses it
// (see AskEnergyFluoIcon.tsx); this stays for surfaces
// (e.g. "Ask the SOP library") that still render the sunburst.

import React from 'react';

interface HeliosMarkProps {
  size?: number;
  className?: string;
}

export default function HeliosMark({ size = 20, className }: HeliosMarkProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      aria-hidden="true"
      className={className}
    >
      <circle cx="12" cy="12" r="3" fill="currentColor" stroke="none" />
      <path
        d="M12 4v2M12 18v2M4 12h2M18 12h2M6.3 6.3l1.4 1.4M16.3 16.3l1.4 1.4M17.7 6.3l-1.4 1.4M7.7 16.3l-1.4 1.4"
        strokeLinecap="round"
      />
    </svg>
  );
}
